class Counter {
	constructor(elem) {
		this.counter = elem;
		this.step = 1;

		this.refs = {
			buttonDecrement: this.counter.querySelector('[data-counter-minus]'),
			buttonIncrement: this.counter.querySelector('[data-counter-plus]'),
			value: this.counter.querySelector('[data-counter-value]'),
		};

		this.count = Number(this.refs.value.textContent) || 1;
		this.maxValue = Number(this.counter.getAttribute('data-counter-max')) || Infinity;

		this.isCartCounter = this.counter.hasAttribute('data-cart-counter');
	}

	updateCount() {
		this.refs.value.textContent = this.count;
	}

	addListeners() {
		this.refs.buttonDecrement.addEventListener('click', this.onDecrement.bind(this));
		this.refs.buttonIncrement.addEventListener('click', this.onIncrement.bind(this));
	}

	onDecrement() {
		if (this.isCartCounter && this.count === 1) {
			const counter = this.refs.buttonDecrement.closest('section').querySelectorAll('.counter');

			counter.forEach((counter) => {
				counter.classList.remove('_active');
				this.counter.nextElementSibling.classList.remove('_active');
			});

			return;
		}

		this.count -= this.step;

		if (this.count === 1 && !this.isCartCounter) {
			this.refs.buttonDecrement.setAttribute('disabled', true);
		}

		this.updateCount();

		if (this.count < this.maxValue) {
			this.refs.buttonIncrement.removeAttribute('disabled');
		}
	}

	onIncrement() {
		if (this.count >= this.maxValue) {
			return;
		}

		this.count += this.step;

		if (this.count >= 1 && !this.isCartCounter) {
			this.refs.buttonDecrement.removeAttribute('disabled');
		}

		this.updateCount();

		if (this.count >= this.maxValue) {
			this.refs.buttonIncrement.setAttribute('disabled', true);
		}
	}
}

document.querySelectorAll('.counter').forEach((elem) => new Counter(elem));

export default Counter;
